var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoMonitor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico-monitor",
    transform: "translate(-2332 -10229)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_97",
    "data-name": "Rectangle 97",
    width: 40,
    height: 40,
    transform: "translate(2332 10229)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ico_monitor",
    d: "M38.021,12H5.065A3.077,3.077,0,0,0,2,15.086V35.657a3.077,3.077,0,0,0,3.065,3.086H17.429v3.6h-.771a.771.771,0,0,0,0,1.543h9.771a.771.771,0,1,0,0-1.543h-.771v-3.6H38.021a3.077,3.077,0,0,0,3.065-3.086V15.086A3.077,3.077,0,0,0,38.021,12ZM24.114,42.343H18.971v-3.6h5.143Zm15.429-6.686A1.53,1.53,0,0,1,38.021,37.2H5.065a1.533,1.533,0,0,1-1.522-1.543V15.086a1.53,1.53,0,0,1,1.522-1.543H38.021a1.533,1.533,0,0,1,1.522,1.543Z",
    transform: "translate(2330.457 10221)",
    fill: "#646464"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMonitor);
export default __webpack_public_path__ + "static/media/ico-monitor.7a23ffa82dd4ef45e48bbe8400d7096f.svg";
export { ForwardRef as ReactComponent };